import React, { useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { MinusIcon, PlusIcon } from "lucide-react";
import { faqs } from "../data/landing";
import { Reveal, STAGGER } from "./Reveal";
import { SectionHeader } from "./SectionHeader";
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  const reduce = useReducedMotion();
  return <section aria-labelledby="faq" className="section-pad border-b border-line" data-id="element-170" data-mp="2a2icelvuq6qz">
      <div className="page-container grid gap-12 lg:grid-cols-12 lg:gap-8" data-id="element-171" data-mp="253f8j4rly6kl">
        <Reveal className="lg:col-span-4" data-id="element-172" data-mp="251b66r9cxfmf">
          <SectionHeader number="11" label="Preguntas" titleId="faq" title="Preguntas frecuentes" data-id="element-173" data-mp="2039jlwcq2y67" />
        </Reveal>
        <Reveal delay={STAGGER} className="lg:col-span-7 lg:col-start-6" data-id="element-174" data-mp="1v46gihgaz20v">
          <ul className="border-t border-line" data-id="element-175" data-mp="op5t505cfs5w">
            {faqs.map((item, i) => {
            const isOpen = open === i;
            const panelId = `faq-panel-${i}`;
            const Icon = isOpen ? MinusIcon : PlusIcon;
            return <li key={item.question} className="border-b border-line" data-id="element-176" data-mp="1klvx01hvhlxa" data-mpi={i}>
                  <h3 data-id="element-177" data-mp="1pmbaqu62gvfs">
                    <button type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpen(isOpen ? null : i)} className="flex min-h-[64px] w-full items-center justify-between gap-6 py-5 text-left font-ui text-[18px] font-bold text-cream transition-colors duration-200 ease-out hover:text-gold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-178" data-mp="1pkgwfypaw1ko">
                      {item.question}
                      <Icon className="h-4 w-4 shrink-0 text-gold" strokeWidth={2.5} aria-hidden="true" data-id="element-179" data-mp="wyxktg0sd056" />
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-180" data-mp="mzq72rq533hj">
                    {isOpen && <motion.div id={panelId} initial={reduce ? false : {
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: "auto",
                  opacity: 1
                }} exit={reduce ? {
                  opacity: 0
                } : {
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.25,
                  ease: [0.22, 1, 0.36, 1]
                }} className="overflow-hidden" data-id="element-181" data-mp="2pmn39s4xdny1">
                        <p className="body-copy pb-7" data-id="element-182" data-mp="38k6hrba5jyru">{item.answer}</p>
                      </motion.div>}
                  </AnimatePresence>
                </li>;
          })}
          </ul>
        </Reveal>
      </div>
    </section>;
}